module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab11/awsop-lab11.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab11/awsop-lab11.component.css
// module chunks = main